import React from "react";
import { Calendar, Clock, Video, ArrowUpRight } from "lucide-react";
import { SectionHeader } from "@/sections/Services";

const CAL_EXTERNAL_URL = process.env.REACT_APP_CAL_URL || "https://cal.com/akwasi-asante-m4ywjm";
const CAL_EMBED_URL = `${CAL_EXTERNAL_URL}${CAL_EXTERNAL_URL.includes("?") ? "&" : "?"}embed=true&theme=dark&layout=month_view&hideEventTypeDetails=false`;

export default function BookCall() {
  return (
    <section
      id="book-call"
      data-testid="book-call-section"
      className="relative py-24 md:py-32 border-t border-white/[0.06]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-start">
          <div className="lg:col-span-5">
            <SectionHeader
              eyebrow="Book a call"
              title="Prefer to talk? Grab a 30-minute slot."
              subtitle="Quick, no-pressure call to walk through your idea, scope and next steps. Pick a time that suits you."
            />

            <ul className="mt-10 space-y-4">
              {[
                { icon: Clock, label: "30 minutes", sub: "Focused, useful conversation" },
                { icon: Video, label: "Video or phone", sub: "Whichever works for you" },
                { icon: Calendar, label: "No commitment", sub: "Free initial discussion" },
              ].map((it) => {
                const Icon = it.icon;
                return (
                  <li
                    key={it.label}
                    className="mk-reveal flex items-center gap-4 rounded-2xl border border-white/10 bg-white/[0.03] p-4"
                  >
                    <div className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-white/10 bg-[#07111F]">
                      <Icon className="h-4 w-4 text-[#00D4FF]" />
                    </div>
                    <div>
                      <div className="text-[14px] font-medium text-white">
                        {it.label}
                      </div>
                      <div className="text-[12px] text-slate-500">{it.sub}</div>
                    </div>
                  </li>
                );
              })}
            </ul>

            <a
              href={CAL_EXTERNAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="book-call-external-link"
              className="mt-8 inline-flex items-center gap-1.5 text-sm font-semibold text-white mk-underline-link"
            >
              Open booking page
              <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>

          <div className="lg:col-span-7">
            <div
              className="mk-reveal mk-card rounded-3xl overflow-hidden p-2 md:p-3"
              data-testid="book-call-embed-wrapper"
            >
              <div className="rounded-2xl overflow-hidden border border-white/10 bg-[#0A1628]">
                <iframe
                  title="Book a call with Mackbe Tech"
                  src={CAL_EMBED_URL}
                  className="w-full block"
                  style={{ minHeight: 720, border: 0 }}
                  loading="lazy"
                  allow="camera *; microphone *; fullscreen; clipboard-read; clipboard-write"
                  data-testid="book-call-iframe"
                />
              </div>
            </div>
            <p className="mt-3 text-center text-[12px] text-slate-500">
              Booking powered by Cal.com — your details stay private.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
